import axios from './axios';

export default class SalesCustomerOrderService {

    getAllCustomerOrders(request, type) {
        return axios.post('/api/customer/order/list?type=' + type, request)
    }
}
